import { createAsyncThunk, createSelector, createSlice } from '@reduxjs/toolkit';
import MediasService from 'services/medias-service';
import { FetchStatus, ResultState } from 'types/common';
import { MediasList } from 'types/medias';
import { RootState } from './index';

const initialState: ResultState<MediasList | null> = {
	data: null,
	status: FetchStatus.IDLE,
	error: null,
};

export const fetchMediasFeedAsync = createAsyncThunk(
	'medias/fetchFeed',
	async () => {
		const mediasList: MediasList = await MediasService.fetchFeed();

		return mediasList;
	},
);

export const mediasFeedSlice = createSlice({
	name: 'medias/feed',
	initialState,
	reducers: {
	},
	extraReducers: (builder) => {
		builder
			// FETCH
			.addCase(fetchMediasFeedAsync.pending, (state) => {
				state.status = FetchStatus.LOADING;
			})
			.addCase(fetchMediasFeedAsync.fulfilled, (state, { payload }) => {
				state.status = FetchStatus.IDLE;
				state.data = payload;
			});
	},
});

const getMediasFeed = (state: RootState) => state.mediasFeed;

export const getMediasFeedData = createSelector(getMediasFeed, feed => feed.data);

export default mediasFeedSlice.reducer;
